module.exports = "./img/a6930f6eacbc3b1678f9e9f9ec3cf218.png";